import { Component, ElementRef, Input, Renderer2, ViewChild } from '@angular/core';

import { SiterecordComment } from 'app/models';

@Component({
  selector: 'siterecord-comment',
  templateUrl: './siterecord-comment.component.html',
  styleUrls: ['./siterecord-comment.component.scss']
})
export class SiterecordCommentComponent {
  @ViewChild('body') body: ElementRef;

  @Input() comment: SiterecordComment;
  @Input() open = false;

  constructor(private readonly renderer: Renderer2) {}

  public collapse(open?: boolean): void {
    if (open == null) {
      if (this.body.nativeElement.classList.contains('in')) {
        this.closeItem();
      } else {
        this.openItem();
      }
    } else if (open) {
      this.openItem();
    } else {
      this.closeItem();
    }
  }

  private openItem(): void {
    this.renderer.addClass(this.body.nativeElement, 'in');
  }

  private closeItem(): void {
    this.renderer.removeClass(this.body.nativeElement, 'in');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/comments/siterecord-comment.component.ts